import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../recoil/cashout/ClientSideConfigSelector';

export default function ConvertCatalogHeader() {
  const { t } = useTranslation(null, { useSuspense: false });
  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        appCurrency,
      } = {},
    },
  } = config;
  return (
    <div className="member-diamonds-subheader row">
      <div className="col-xs-12">
        <div className="member-diamonds-subheader-menu">
          <span className="text-capitalize">{t('convert_title', { appCurrency: t(appCurrency?.toLowerCase()) })}</span>
          <div className="member-diamonds-subheader-menu-items" />
        </div>
        <hr />
      </div>
    </div>
  );
}
